import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHardCode } from "../../hooks";
import "./button.css";

const Button = ({ name, onClick, disabled = "x", moduleClass, bsClass }) => {
  return (
    <button
      className={`saara_custom_btn form__btn ${
        disabled && "form__btn__disabled"
      }  ${moduleClass}`}
      onClick={onClick}
      disabled={disabled}
    >
      {name}
    </button>
  );
};

// This button will be shown in the end when user successfully raises a exchange/return request.
const RaiseNewRequestButton = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const [isLoader, setIsLoader] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const {
    SHOPIFY_SHOP_OBJECT,
    CURRENT_STORE_NAME,
    STEVE_MAIDEN,
    PURE_FEMALE_TRANSLATION,
  } = useHardCode();
  // Handles when user wants to create another return request
  const raiseANewRequestHandler = async () => {
    if (disabled) return;

    setIsLoader(true);
    setDisabled(true);

    // Quantity is already updated
    navigate("/items");
  };

  // Show Raise new request only if user has more than 0 product
  if (productDetailsState.orderInfo.length <= 0) return null;

  return (
    <div className="shop-more-btn-2">
      <span className="return_exchange_more" onClick={raiseANewRequestHandler}>
        {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.steve_maiden
          ? STEVE_MAIDEN.return_more
          : `${
              SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                ? PURE_FEMALE_TRANSLATION.return_exchange_more
                : storeConfigState?.themeConfig?.return_exchange_more
            }`}
      </span>

      {isLoader && (
        <div
          className="saara-spinner-border saara-spinner-border-sm saara-spinner-border-margin"
          role="status"
        >
          <span className="saara-visually-hidden"></span>
        </div>
      )}
    </div>
  );
};

export { Button, RaiseNewRequestButton };
